<div
  id="notification-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_300px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions tw-items-center tw-gap-x-3">
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="notification-table"
      class="matp-table"
      mat-table
      matSort
      matSortActive="releaseAt"
      matSortDirection="desc"
      [dataSource]="dataSource"
      class="matp-table"
    >
      <!-- 投稿日時(予定) -->
      <ng-container matColumnDef="releaseAt">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-min">
          <div mat-sort-header class="matp-table-header-title">
            投稿日時(予定)
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
        >
          {{ element.releaseAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>
      <!-- 投稿ステータス -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="!tw-w-24">
          <div mat-sort-header class="matp-table-header-title">
            投稿ステータス
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="statusKeyword"
              name="statusKeywordFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (status of statusList; track $index) {
                <mat-option [value]="status">{{ status }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
        >
          {{ element.status }}
        </td>
      </ng-container>
      <!-- 最終編集者 -->
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">最終編集者</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="updatedBy"
              type="text"
              [(ngModel)]="updatedByKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="updatedby-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearUpdatedByFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
          class="!tw-truncate !tw-max-w-8"
        >
          {{ element.updatedBy }}
        </td>
      </ng-container>
      <!-- 最終編集日時 -->
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-min">
          <div mat-sort-header class="matp-table-header-title">
            最終編集日時
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
        >
          {{ element.updatedAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>
      <!-- タイトル -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">タイトル</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="title"
              type="text"
              [(ngModel)]="titleKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="title-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTitleFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
          class="!tw-truncate !tw-max-w-8"
        >
          {{ element.title }}
        </td>
      </ng-container>
      <!-- 内容 -->
      <ng-container matColumnDef="content">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            内容(1行目のみ)
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="content"
              type="text"
              [(ngModel)]="contentKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="content-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearContentFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="tw-max-w-72 tw-truncate"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
        >
          {{ element.content }}
        </td>
      </ng-container>
      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="!tw-w-56"
          [ngClass]="{
            '!tw-bg-gray-300': isPosted(element.releaseAt),
            'tw-text-gray-500': isPosted(element.releaseAt),
          }"
        >
          <div class="tw-flex">
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="edit-btn"
                color="primary"
                (click)="updated.emit(element)"
              >
                <mat-icon>edit</mat-icon>
                <span>編集</span>
              </button>
            </div>
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="delele-btn"
                color="primary"
                (click)="deleted.emit(element)"
              >
                <mat-icon>delete</mat-icon>
                <span>削除</span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="notification-table-paginator"
    [length]="dataSource.filteredData.length"
    [pageSize]="10"
    hidePageSize
    showFirstLastButtons
  ></mat-paginator>
</div>
